import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotService } from '../shared/Forgot.Service';
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-identity-mgt-eb-ga-am',
  templateUrl: './identity-mgt-eb-ga-am.component.html',
  styleUrls: ['./identity-mgt-eb-ga-am.component.scss']
})
export class IdentityMgtEbGaAmComponent implements OnInit {
  public type = '';
  public selected = '';
  public lastnamepass = '';
  public lastnameid = '';
  public uid = '';
  public pasteData = '';
  public pasteInd = 'N';
  public userId: string;
  public pwd: string;
  public email: string;
  error: boolean;
  message: any;
  public resp: any;
  public showId = false;
  public showpwd = false;
  public forgot: any;
  public showPlaceholder: boolean;
  public isLoading = false;
  public validate = true;
  public errorField: any = {
    option: false,
    uid: false,
    lastnamepass: false,
    email: false,
    lastnameid: false
  };
  constructor(private router: Router,private forgotService: ForgotService, private appInsightsService: AppInsightsService) {}
  
  @ViewChild('user') public user: ElementRef;
  @ViewChild('lastpass') public lastpass: ElementRef;
  @ViewChild('em') public em: ElementRef;
  @ViewChild('lastid') public lastid: ElementRef;
  
  resetValidation() {
    this.errorField = {
     option: false,
     uid: false,
     lastnamepass: false,
     email: false,
     lastnameid: false
    };
    this.email = this.lastnamepass = this.lastnameid = this.uid = '';
  }
  
  emailCheck() {
    const regex = /^(([^<>()\[\]\\.,;:\s@"*~]+(\.[^<>()\[\]\\.,;:\s@"*~]+)*)|(".+"))@((([a-zA-Z0-9\-]+\.)+[a-zA-Z0-9]{2,10}))$/;
    if (!regex.test(this.email)) {
      return true;
    } else {
      return false;
    }
  }
  
  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }
  
  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }
  
  
  focusOnInput() {
    let setError = false;   
    if (this.selected === 'pass') {
	  	if (!!this.errorField.uid) {
	      setError = true;
	      setTimeout(() => this.user.nativeElement.focus(), 0);
	      setTimeout(() => this.user.nativeElement.select(), 0);
	      window.scrollTo(0,this.user.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
	    } else if (!!this.errorField.lastnamepass) {
	      setError = true;
	      setTimeout(() => this.lastpass.nativeElement.focus(), 0);
	      setTimeout(() => this.lastpass.nativeElement.select(), 0);
	      window.scrollTo(0,this.lastpass.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
	    } 
  	} else if (this.selected === 'id') {
  		if (!!this.errorField.email) {
	      setError = true;
	      setTimeout(() => this.em.nativeElement.focus(), 0);
	      setTimeout(() => this.em.nativeElement.select(), 0);
	      window.scrollTo(0,this.em.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
	    } else if (!!this.errorField.lastnameid) {
	      setError = true;
	      setTimeout(() => this.lastid.nativeElement.focus(), 0);
	      setTimeout(() => this.lastid.nativeElement.select(), 0);
	      window.scrollTo(0,this.lastid.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
	    }
  	} 
    return setError;
  }

  isErrorPresent() {
  	if (this.selected === 'pass') {
	  	if (!this.errorField.uid && !this.errorField.lastnamepass) {
	      return false;
	    } else {
	      return true;
	    }
  	} else if (this.selected === 'id') {
  		if (!this.errorField.email && !this.errorField.lastnameid) {
	      return false;
	    } else {
	      return true;
	    }
  	} else {
  		return true;
  	}
    
  }

  validateAllFields() {
    let fields = [];
    if (this.selected === 'pass') {
	  	fields = ['uid', 'lastnamepass'];
  	} else if (this.selected === 'id') {
  		fields = ['email', 'lastnameid'];
  	}
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
      isErrPresent = this.validateFields(fields[j]);
      if (isErrPresent) {
        break;
      }
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }
  
  validateFields(model) {
    let error = false;
    this.validate = true;

   if (model === 'uid') {
    if (!this.uid) {
      this.errorField.uid = true;
      error = true;
    } else {
      this.errorField.uid = false;
      this.ifAtleastOneFieldValidated(model);
    }
   } 
   
   if (model === 'lastnamepass') {
    if (!this.lastnamepass) {
      this.errorField.lastnamepass = true;
      error = true;
    } else {
      this.errorField.lastnamepass = false;
      this.ifAtleastOneFieldValidated(model);
    }
   }
   
   if (model === 'email') {
    if (!this.email) {
      this.errorField.email = true;
      error = true;
    } else if (this.emailCheck()) {
      this.errorField.email = true;
      error = true;
    }else {
      this.errorField.email = false;
      this.ifAtleastOneFieldValidated(model);
    }
   }
   
   if (model === 'lastnameid') {
    if (!this.lastnameid) {
      this.errorField.lastnameid = true;
      error = true;
    } else {
      this.errorField.lastnameid = false;
      this.ifAtleastOneFieldValidated(model);
    }
   }

    if (((this.selected === 'pass' && !!this.uid && !!this.lastnamepass) ||
    (this.selected === 'id' && !!this.email && !!this.lastnameid)) &&
     !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }
  
  ngOnInit() {
    console.log('eb-ga-am loaded');
    window.scroll(0,0);
    this.showPlaceholder = true;
    this.appInsightsService.logEvent("Forgot UI Page - Employee Benefits");
    this.forgotService.getUid().subscribe( res => {
      this.userId = res;
      if (this.userId) {
        this.showId = true;
      }
    });
    this.forgotService.getType().subscribe( res => {
      this.pwd = res;
      if (this.pwd === 'pwd') {
        this.showpwd = true;
      }
    });
  }

  continue() {

    if (!this.validateAllFields()) {
      const userType = 'ebbga';
      setTimeout(() => {
        window.scroll(0,0);
        this.error = false;
        this.isLoading = true;
        this.validate = true;
      });
      if (this.selected && this.selected === 'id') {
        const email = this.email;
        const lastName = this.lastnameid;
        const json = JSON.stringify({ email, lastName, userType });
        console.log(json);
        this.forgotService.getUserId(json).subscribe( res => {
          this.resp = res;
          if (this.resp) {
            setTimeout(() => {
              this.isLoading = false;
            });
            if (this.resp.status_code !== '200') {
              this.message = this.resp.message;
              this.error = true;
              this.validate = false;
              window.scroll(0,0);
            } else {
              this.userId = this.resp.userId;
              this.showId = true;
              this.error = false;
            }
          }
        });
      }
      if (this.selected && this.selected === 'pass') {
        const userId = this.uid;
        const lastName = this.lastnamepass;
        const json = JSON.stringify({ userId, lastName , userType});
        console.log(json);
        this.forgotService.getPassword(json).subscribe( res => {
            this.forgot =  res;           
            if (this.forgot) {
              if (this.forgot.status_code && this.forgot.status_code !== '200') {
                  setTimeout(() => {
	                this.isLoading = false;
	              });
                  this.message = this.forgot.message;
                  this.error = true;
                  this.validate = false;
                  window.scroll(0,0);
                } else {
                    this.error = false;
                    this.forgotService.setQuestions(this.forgot.questions);
                    this.forgotService.setType('pwd');
                    this.forgotService.setUserType(userType);
                    this.router.navigate(['/questions']);
                }
            }
        });
      }
    } else {
    	this.focusOnInput();
    }
  }


  back() {
    this.router.navigate(['']);
  }

  paste(event: ClipboardEvent) {
    if (event && event.clipboardData) {
      this.pasteData = event.clipboardData.getData('text');
    }
  }
}
